import { ValidatePhoneNumberLengthResult } from "libphonenumber-js";

export const phoneErrors: Record<ValidatePhoneNumberLengthResult, string> = {
  INVALID_COUNTRY: "Phone number with invalid country code",
  INVALID_LENGTH: "Phone number with invalid length",
  NOT_A_NUMBER: "Must be a number",
  TOO_LONG: "Phone number too long",
  TOO_SHORT: "Phone number too short",
};
